import Modal from './modal'

export default class MultiStepModal extends Modal {
  componentWillUpdate(nextProps) {
    if (nextProps.activeStep === this.props.activeStep) return

    this.scrollToTop()
  }

  scrollToTop = () => {
    if (!this.modalContainer) return

    this.modalContainer.scrollTop = 0
  }
}
